// Removes AI-generated citation markers like "[5]", "[3][10][16]", or "[3, 10]"
// from display text. These come from web-search-grounded model output and are
// noise in the product UI. Also tidies the whitespace a stripped marker leaves
// behind (e.g. a space before a period, or a doubled space mid-sentence).
//
// Only NUMERIC brackets are removed, so genuine text like "[note]" is untouched.
export function stripCitations(text: string | null | undefined): string {
  if (!text) return text ?? "";
  return text
    .replace(/\s*\[\d+(?:\s*,\s*\d+)*\]/g, "")
    .replace(/\s+([.,;:!?])/g, "$1")
    .replace(/[ \t]{2,}/g, " ")
    .trim();
}
